export default (style)=>{
  return(`

    .Opacity03 {
      opacity: 0.3;
    }

    .Opacity05 {
      opacity: 0.5;
    }
  `)
}
